<div class="text-center">
    <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
        <h1 class="mb-4"><strong>Error 404</strong></h1>
        <p class="mb-4">El recurso que está solicitando no existe. Por favor contactese con el administrador del sistema.</p>
        <a href="javascript: history.back();" class="btn btn-link">Regresar</a>
    </div>
</div>
